import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1888e29c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"rotate\" data-v-1888e29c>S</div><div class=\"rotate\" data-v-1888e29c>D</div><div class=\"rotate\" data-v-1888e29c>N</div><div class=\"rotate\" data-v-1888e29c>U</div><div class=\"rotate\" data-v-1888e29c>O</div><div class=\"rotate\" data-v-1888e29c>W</div>", 6)
const _hoisted_8 = [
  _hoisted_2
]
const _hoisted_9 = { class: "flex-column bars" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex-column wounds", _ctx.editMode ? 'red' : ''])
    }, _hoisted_8, 2),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radioArray, (wound, woundIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["wound-box", [woundIndex >= this.wounds ? (_ctx.editMode ? 'strike-through red' : 'strike-through' ): '', { pointer: _ctx.editMode }]]),
          onClick: ($event: any) => (_ctx.clickWound(woundIndex + 1))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wound, (bool) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["health-button button", _ctx.healthButtonClasses(bool, woundIndex + 1)]),
              onClick: ($event: any) => (_ctx.clickRadio(bool, woundIndex + 1, $event))
            }, null, 10, _hoisted_11))
          }), 256))
        ], 10, _hoisted_10))
      }), 256))
    ])
  ]))
}